var React = require('react');

function IconTwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.252 3.185a13.656 13.656 0 01-3.917 1.074 6.858 6.858 0 003-3.771A13.76 13.76 0 0128 2.151a6.827 6.827 0 00-11.625 6.213A19.368 19.368 0 012.316 1.236a6.83 6.83 0 002.112 9.105 6.837 6.837 0 01-3.098-.857v.085a6.83 6.83 0 005.487 6.69 6.985 6.985 0 01-1.798.24c-.43 0-.86-.043-1.283-.126a6.818 6.818 0 006.363 4.731 13.692 13.692 0 01-8.48 2.915c-.542 0-1.082-.028-1.619-.088A19.288 19.288 0 0010.456 27c10.643.074 19.333-8.495 19.408-19.14v-.269l-.023-.883a13.62 13.62 0 003.411-3.524","fill":"#2777b8","fillRule":"evenodd"}));
}

IconTwitterInline.defaultProps = {"viewBox":"0 0 34 27"};

module.exports = IconTwitterInline;

IconTwitterInline.default = IconTwitterInline;
